module.exports = __webpack_public_path__ + "88bb142e9c0bd307c4f8b0304d20c5e0.jpg";